import {inject, Injectable} from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';
import {AppStore} from '../store/app.store';

export type AppRoute = 'lookup' | 'compare' | 'results' | 'selection' | 'settings';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private router = inject(Router);
  private appStore = inject(AppStore);
  private returnTo: string = '';

  navigate(path: AppRoute | [AppRoute, ...string[]], extras?: NavigationExtras) {
    const pathArray = Array.isArray(path) ? path : [path];
    this.returnTo = extras?.queryParams?.['returnTo'] ?? this.returnTo;
    this.router.navigate([this.appStore.session_id(), ...pathArray], extras);
  }

  back() {
    this.navigate((this.returnTo ?? 'lookup') as AppRoute);
    this.returnTo = '';
  }
}
